import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[70vh] grid place-items-center px-6">
      <div className="text-center max-w-md" data-testid="payment-cancel-page">
        <XCircle className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
        <h1 className="font-display text-2xl font-semibold">Payment cancelled</h1>
        <p className="text-muted-foreground mt-2">No worries — your card wasn't charged. You can complete your booking anytime.</p>
        <Button onClick={() => navigate("/activities")} className="rounded-full mt-6">Back to activities</Button>
      </div>
    </div>
  );
}
